import { createGlobalStyle, css } from 'styled-components'

import { isIframe } from '@common/constants'

import WorkSans from '../public/fonts/WorkSans-VariableFont_wght.ttf'

const walletConnectOnIframe = css`
    .walletconnect-modal__base {
        max-height: 554px;
        .walletconnect-qrcode__text {
            font-size: 20px;
        }
        svg.walletconnect-qrcode__image {
            height: 378px;
        }
        .walletconnect-modal__footer {
            margin-top: 40px;
        }
        .walletconnect-connect__buttons__wrapper__wrap {
            transform: scale(0.9);
        }
    }
`

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Work Sans';
    src: url(${WorkSans}) format('truetype');
    font-style: normal;
    font-display: swap;
  }

  :root{
    --black: ${properties => properties.theme.variables.colorText};
    --white: ${properties => properties.theme.variables.colorBackground};
    --gray: ${properties => properties.theme.variables.colorGray.primary};
    
    --font-WorkSans: 'Work Sans';
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    ${isIframe && 'height: 650px;'}
  }

  body {
    font-family: --font-WorkSans, sans-serif;
    font-style: normal;
    font-weight: normal;
    background: ${properties => properties.theme.variables.colorBackground};
    color: var(--black);
    ${isIframe && 'height: 650px;'}
  }

  input[type="number"] {
    -webkit-appearance: textfield;
       -moz-appearance: textfield;
            appearance: textfield;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  ol, ul {
    padding: 0;
  }

  h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
    margin: 0;
  }

  p {
    margin: 0;
  }

  /* hr {
    border-color: ${properties => properties.theme.variables.lineBorder};
    background-color: ${properties => properties.theme.variables.lineBorder};
    color: ${properties => properties.theme.variables.lineBorder};
  } */


  /* walletconnect scale down to fit on iframes without scroll breaking */
  ${isIframe && walletConnectOnIframe}
`
